import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { BsTwitter, BsLinkedin, BsGithub } from "react-icons/bs";
import { FiMail } from "react-icons/fi";
import "../contact/Contact.css";

const Contact = () => {
  const form = useRef();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userTel, setUserTel] = useState("");
  const [userMessage, setUserMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [visible, setVisible] = useState(true);

  function openModal() {
    setUserName("");
    setUserEmail("");
    setUserTel("");
    setUserMessage("");
    setIsModalOpen(true);
  }

  function closeModal() {
    setIsModalOpen(false);
  }

  const validateForm = () => {
    const errors = {};

    if (!form.current.user_name.value.trim()) {
      errors.user_name = "Name field is required";
    }

    if (!form.current.user_email.value.trim()) {
      errors.user_email = "Email is required";
    } else if (
      !/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/i.test(
        form.current.user_email.value
      )
    ) {
      errors.user_email = "Invalid email format";
    }

    if (!form.current.user_phone.value.trim()) {
      errors.user_phone = "Telephone is required";
    } else if (!/^\d{11}$/i.test(form.current.user_phone.value)) {
      errors.user_phone =
        "Invalid telephone number. Please enter a 11-digit number";
    }

    return errors;
  };

  const sendEmail = (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    emailjs
      .sendForm(
        "service_2z9i9jf",
        "template_1wa3mxt",
        form.current,
        "9KPTNNmDoSwnYVT2hR_Mf"
      )
      .then(
        () => {
          setLoading(false);
          openModal();
          form.current.reset();
          setErrors({});
        },
        (err) => {
          setLoading(false);
          setErrorMessage(err);
          alert(JSON.stringify(err));
          console.log(err);
        }
      );
  };

  function sendResetFields() {
    setSuccessMessage("We've received your email. We would respond shortly!");
    setVisible(true);
    setUserName("");
    setUserEmail("");
    setUserTel("");
    setUserMessage("");
  }

  const mobileSendEmail = (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    emailjs
      .sendForm(
        "service_2z9i9jf",
        "template_1wa3mxt",
        form.current,
        "Um4MVP1rZ_ZkEQjqx"
      )
      .then(
        () => {
          setLoading(false);
          form.current.reset();
          sendResetFields();
          setTimeout(() => {
            setVisible(false);
            setSuccessMessage("");
          }, 5000);
          setErrors({});
        },
        (err) => {
          setLoading(false);
          setSuccessMessage(
            "There was an error processing your request. Please try again"
          );
          setVisible(true);
          setTimeout(() => {
            setVisible(false);
            setSuccessMessage("");
          }, 5000);
          setErrorMessage(err);
          alert(JSON.stringify(err));
        }
      );
  };

  return (
    <>
      <div className="contact">
        <h1 style={{ color: "#5c6e58" }}>
          CONTACT<span style={{ color: "#ad4328" }}> ME.</span>
        </h1>

        <div className="grid4form">
          <div className="info">
            <h5>
              Hi there! I am open for opportunities to work with you. Let's
              connect and create magic together!
            </h5>

            <p>ladeolu2016@gmail.com</p>
            <p>+234-813-6128-748</p>
            <p>Lagos, Nigeria</p>

            <div id="socials">
              <a
                href="https://twitter.com/lanreadeolu"
                target="_blank"
                rel="noreferrer"
              >
                <BsTwitter />
              </a>
              <a
                href="mailto:ladeolu2016@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                <FiMail />
              </a>
              <a
                href="http://linkedin.com/in/lanre-onasanya-2a357a112"
                target="_blank"
                rel="noreferrer"
              >
                <BsLinkedin />
              </a>
              <a
                href="https://github.com/lanreonasanya02"
                target="_blank"
                rel="noreferrer"
              >
                <BsGithub />
              </a>
            </div>
          </div>

          <div className="form">
            <form action="">
              {/* <input type="hidden" name="contact_number" /> */}

              <div className="field">
                <label htmlFor="user_name">Name*</label>
                <input
                  type="text"
                  name="user_name"
                  id="user_name"
                  placeholder="e.g. John Doe"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                />
                {errors.user_name && (
                  <p className="form-error-message">{errors.user_name}</p>
                )}
              </div>

              <div className="field">
                <label htmlFor="user_email">Email Address*</label>
                <input
                  type="email"
                  name="user_email"
                  id="user_email"
                  placeholder="e.g. johndoe@example.com"
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                />
                {errors.user_email && (
                  <p className="form-error-message">{errors.user_email}</p>
                )}
              </div>

              <div className="field">
                <label htmlFor="user_phone">Phone*</label>
                <input
                  type="tel"
                  name="user_phone"
                  id="user_phone"
                  placeholder="Type your 11-digit number here..."
                  value={userTel}
                  onChange={(e) => setUserTel(e.target.value)}
                />
                {errors.user_phone && (
                  <p className="form-error-message">{errors.user_phone}</p>
                )}
              </div>

              <div className="field">
                <label htmlFor="message">Message*</label>

                <textarea
                  name="message"
                  id=""
                  cols="40"
                  rows="3"
                  placeholder="Type your message here..."
                  value={userMessage}
                  onChange={(e) => setUserMessage(e.target.value)}
                ></textarea>
              </div>

              <button
                id="button"
                onClick={sendEmail}
                className={`btn ${
                  userName && userEmail && userTel && userMessage
                    ? "btn-active"
                    : "btn-disabled"
                }`}
              >
                {loading ? "Sending" : "Send Email"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
